import { http } from "api/http";

const getIncomeTaxDashboard = ({ queryKey }) => {
  return http.get("/incometaxtan-dashboard", { params: { ...queryKey[1] } });
};

const getTanClientVerification = ({ queryKey }) => {
  return http.get("incometaxtan-dashboard/verification", { params: { ...queryKey[1] } });
};

const exportTanInvalid = (data: any) => {
  return http.post("/incometaxtan-dashboard/exportTanInvalid", data);
};

const incometaxConfigStatus = () => {
  return http.get("incometaxtan-dashboard/config-status");
};

const getformUdinAnalytics = ({ queryKey }) => {
  const assessmentYear = queryKey[1];
  return http.get("incometaxtan-dashboard/forms-udin", { params: { assessmentYear } });
};

const getformAnalytics = ({ queryKey }) => {
  const assessmentYear = queryKey[1];
  return http.get("incometaxtan-dashboard/forms-analytics", { params: { assessmentYear } });
};

const getTdsAnalytics = ({ queryKey }: any) => {
  return http.get("incometaxtan-dashboard/tds-analytics", { params: { ...queryKey[1] } });
};

const getformCorrectionAnalytics = ({ queryKey }) => {
  const assessmentYear = queryKey[1];
  return http.get("incometaxtan-dashboard/forms-correction-analytics", {
    params: { assessmentYear },
  });
};

const getExcelEProceedingNoticesCount = ({ queryKey }) => {
  return http.get("incometaxtan-dashboard/eProceedingNotices-excel", { params: { ...queryKey[1] } });
};

const getTracesNoticesCount = ({ queryKey }) => {
  return http.get("incometaxtan-dashboard/tracesNotices", { params: { ...queryKey[1] } });
};

const getExcelFyaEvents = ({ queryKey }) => {
  return http.get("incometaxtan-dashboard/fya-events-excel", { params: { ...queryKey[1] } });
};

const getExcelResponseDueEvents = ({ queryKey }) => {
  return http.get("incometaxtan-dashboard/response-due-events-excel", { params: { ...queryKey[1] } });
};

const getTracesIssueEvents = ({ queryKey }) => {
  return http.get("incometaxtan-dashboard/trace-issue-event", { params: { ...queryKey[1] } });
}
const getTraceClientVerification = ({ queryKey }) => {
  return http.get("incometaxtan-dashboard/verification-traces", { params: { ...queryKey[1] } });
};

const getClientVerification = ({ queryKey }) => {
  return http.get("incometaxtan-dashboard/verification", { params: { ...queryKey[1] } });
};

export {
  getIncomeTaxDashboard,
  getTanClientVerification,
  incometaxConfigStatus,
  getformUdinAnalytics,
  getformAnalytics,
  getTdsAnalytics,
  getformCorrectionAnalytics,
  exportTanInvalid,
  getExcelEProceedingNoticesCount,
  getTracesNoticesCount,
  getExcelFyaEvents,
  getExcelResponseDueEvents,
  getTracesIssueEvents,
  getTraceClientVerification,
  getClientVerification
};
